import React from "react";
import { classnames, Icon } from "@culturehq/components";
import { SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";
import { Trans } from "app/utils";
import { CurrentOption } from "./EffectsSDKCameraRecorder";
import MicrophoneIcon from "../icons/MicrophoneIcon";

interface AudioOptionsProps {
  audioDevices: { label: any; value: any }[];
  currentOption: CurrentOption;
  isDisableOption: (option: CurrentOption) => boolean;
  onSelectOption: (option: CurrentOption) => void;
  onSelectedAudioDevice: (value: string | SelectValueWithCategory | null) => void;
  selectedAudioDeviceState: string | SelectValueWithCategory | null;
}

const AudioOptions: React.FC<AudioOptionsProps> = ({
  audioDevices,
  currentOption,
  isDisableOption,
  onSelectOption,
  onSelectedAudioDevice,
  selectedAudioDeviceState
}) => {
  const isAudioDevice = (device: string) => {
    if (selectedAudioDeviceState) return selectedAudioDeviceState === device;

    return false;
  };

  return (
    <div
      data-testid="audio-options"
      className={classnames("Options-Container__source", isDisableOption("audio") ? "disabled" : "")}
    >
      {currentOption === "audio" && (
        <div className="option-menu option-menu__audio chq-ffd--sl--opts chq-ffd--sl--opts-open">
          {audioDevices.map(audioDevice => (
            <button
              key={audioDevice.value}
              onClick={() => onSelectedAudioDevice(audioDevice.value)}
              aria-current={isAudioDevice(audioDevice.value)}
              aria-label={`audio device ${audioDevice.value}`}
              type="button"
              className="chq-pbn"
              data-testid={`audio-device-${audioDevice.value}`}
            >
              {audioDevice.label}
            </button>
          )
          )}
        </div>
      )}
      <div
        className="option"
        onClick={() => onSelectOption("audio")}
        data-testid="audio-option-button"
      >
        <div className="icon-container">
          {currentOption === "audio" ? (
            <Icon className="icon-container__icon" icon="close" />
          ) : <MicrophoneIcon className="icon-container__icon" />}
        </div>
        <span className="option-legend"><Trans>Audio</Trans></span>
      </div>
      <div
        className="arrow"
        onClick={() => onSelectOption("audio")}
        data-testid="audio-option-arrow"
      >
        <span aria-hidden="true" className={classnames("chq-dd--caret", { "chq-dd--caret-ex ": currentOption === "audio" })} />
      </div>
    </div>
  );
};

export default AudioOptions;
